var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-theme"},[_c('CardLarge',{staticClass:"center"},[_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]),_c('Themes'),_c('CTA',{attrs:{"disabled":!_vm.minimumThemesSelected,"label":_vm.buttonLabel,"to":{ name: 'statements' }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }